import Grid from '@material-ui/core/Grid'
import {
  createTheme,
  makeStyles,
  MuiThemeProvider
} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { customInputStyle } from '../../assets/jss'
import { GridItem } from '../index'
import 'dayjs/locale/es'

const theme = createTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        margin: '0px !important'
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: '11px !important'
      },
      '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
        borderColor: '#4A90E2',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderColor: 'rgba(0, 0, 0, 0.23)'
        }
      },
    },
    MuiInputBase: {
      root: {
        backgroundColor: '#ffffff94',
        fontSize: 'small  !important'
      }
    },
    MuiPopover: {
      paper: {
        backgroundColor: '#fff !important'
      }
    },
    MuiAutocomplete: {
      inputRoot: {
        // padding: "0px !important"},
        popper: {},
        option: {
          fontSize: 'small  !important'
        }
      },
      PrivateNotchedOutline: {
        legendLabelled: {},
        legendNotched: {
          maxWidth: '0px !important'
        }
      }
    }
  }
})

const useStyles = makeStyles(customInputStyle)

export default function CustomDateNew(props) {
  const classes = useStyles()
  const {
    id,
    disabled,
    labelText,
    value,
    onChange,
    error,
    success,
    sm,
    md,
    maxDate,
    minDate,
    onKeyPress
  } = props
  const labelClasses = classNames({
    [' ' + classes.labelRootError]: error,
    [' ' + classes.labelRootSuccess]: success && !error
  })
  return (
    <GridItem xs={12} sm={sm === null ? 12 : sm} md={md}>
      <MuiThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <Grid container>
            <DesktopDatePicker
              id={id}
              label={labelText}
              inputFormat="DD/MM/YYYY"
              views={['year', 'month', 'day']}
              value={value}
              disabled={disabled}
              onChange={onChange}
              maxDate={maxDate}
              minDate={minDate}
              renderInput={params => (
                <TextField onKeyDown={onKeyPress} {...params} />
              )}
              className={classes.labelRoot + labelClasses}
            />
            <ReactTooltip />
          </Grid>
        </LocalizationProvider>
      </MuiThemeProvider>
    </GridItem>
  )
}

CustomDateNew.propTypes = {
  formControlProps: PropTypes.object,
  id: PropTypes.string,
  style: PropTypes.object,
  labelText: PropTypes.node,
  error: PropTypes.bool,
  success: PropTypes.bool,
  sm: PropTypes.number,
  md: PropTypes.number,
  disabled: PropTypes.bool,
  onKeyPress: PropTypes.func
}
